import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { hasCommentingFeature, hasDeepCommentingFeature } from '../utils/features';
import { useCollaborationSidebarStateShallowValue } from '../store/collaborationSidebarProvider';
export default function useHasCommentingFeature() {
  "use memo";

  const $ = _c(2);
  const enabledFeatures = useCollaborationSidebarStateShallowValue(_temp);
  let t0;
  if ($[0] !== enabledFeatures) {
    t0 = hasCommentingFeature(enabledFeatures);
    $[0] = enabledFeatures;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(state) {
  var _state$enabledFeature;
  return (_state$enabledFeature = state.enabledFeatures) !== null && _state$enabledFeature !== void 0 ? _state$enabledFeature : [];
}
export const useHasDeepCommentingFeature = () => {
  "use memo";

  const $ = _c(2);
  const enabledFeatures = useCollaborationSidebarStateShallowValue(_temp2);
  let t0;
  if ($[0] !== enabledFeatures) {
    t0 = hasDeepCommentingFeature(enabledFeatures);
    $[0] = enabledFeatures;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp2(state) {
  var _state$enabledFeature2;
  return (_state$enabledFeature2 = state.enabledFeatures) !== null && _state$enabledFeature2 !== void 0 ? _state$enabledFeature2 : [];
}